module.exports = __webpack_public_path__ + "img/cita.4d84bdc8.svg";